var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCacheManagement01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cache Management") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.26,10.32V6.05a.89.89,0,0,1,.89-.89h0a.89.89,0,0,1,.89.89v4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,10.51H16.1a1.11,1.11,0,0,1,1.11,1.11v7.22H7.09V11.62A1.11,1.11,0,0,1,8.2,10.51h3.08"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.09,
    y1: 12.48,
    x2: 17.21,
    y2: 12.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.15,
    y1: 16.46,
    x2: 12.15,
    y2: 18.84
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.65,
    y1: 14.08,
    x2: 9.65,
    y2: 18.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.65,
    y1: 14.97,
    x2: 14.65,
    y2: 18.84
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.15,23.35A11.35,11.35,0,1,1,23.5,12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCacheManagement01);
export default __webpack_public_path__ + "static/media/Cache_Management_01.1a4adddfa79932d8087e2eda0793c1ab.svg";
export { ForwardRef as ReactComponent };